import { render, staticRenderFns } from "./SmsSummary.vue?vue&type=template&id=6f9bec26&"
import script from "./SmsSummary.vue?vue&type=script&lang=js&"
export * from "./SmsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports